import React, { Component } from 'react'
import ReactDatePicker from 'react-day-picker'
import MomentLocaleUtils from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';
import styled, { css } from 'styled-components';
import moment from 'moment';
import 'moment/min/locales'

const StyledDatePicker = styled(ReactDatePicker)`${
  (props) => {
    if (!props.styled) return '';

    const bgc = '#8B9898';
    let hbgc = props.styled && props.styled.selector && props.styled.selector.hover.backgroundColor;
    let hfc = props.styled && props.styled.selector && props.styled.selector.hover.color;
    let dpta = props.styled && props.styled.textAlign ? props.styled.textAlign : 'left';
    let nbo = props.styled && props.styled.navButtonOffset ? props.styled.navButtonOffset : null;
    
    return css`
    && {
      .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
        background-color: ${props => css`${props.styled && props.styled.selector && props.styled.selector.backgroundColor}!important`}
        &:hover {
          background-color: ${hbgc}!important;
          color: ${hfc}!important;
        }
      }
      &.DayPicker:not(.DayPicker--interactionDisabled) .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover{
        background-color: ${hbgc}!important;
        color: ${hfc}!important;
      }
      .DayPicker-NavButton--prev {
        width: 0;
        height: 0;
        margin-top: 5px;
        right: ${nbo ? 'auto' : '1.8em'};
        left: ${nbo ? nbo : 'auto'};
        border-top: 7px solid transparent;
        border-bottom: 6px solid transparent;
        border-right: 10px solid ${bgc};
        background-image: initial !important;
        &:hover {
          border-right: 10px solid ${hbgc};
        }
      }      
      .DayPicker-NavButton--next {
        width: 0;
        height: 0;
        margin-top: 5px;
        right: ${nbo ? nbo : '1.8em'};
        border-top: 7px solid transparent;
        border-bottom: 6px solid transparent;
        border-left: 10px solid ${bgc};
        background-image: initial !important;
        &:hover {
          border-left: 10px solid ${hbgc};
        }
      }
      
      .DayPicker-Caption {
         text-align: ${dpta};
      }
    }`;
  }
}`;

export default class DatePicker extends Component {

  onMonthChange(value) {
    this.props.onMonthChange(value)
  }

  onDayClick(day, modifiers = {}) {
    this.props.onDayClick(day, modifiers)
  }

  render() {
    return (
      <StyledDatePicker
        {...this.props}
        localeUtils={MomentLocaleUtils}
        locale={this.props.region}
        onDayClick={this.onDayClick.bind(this)}
        onMonthChange={this.onMonthChange.bind(this)}
        renderDay={this.props.renderDay}
      >
        {this.props.children}
      </StyledDatePicker>
    )

  }
}
